import Vue from 'vue'
import Vuex from 'vuex'
import shoplogin from './modules/shoplogin'
import coupons from './modules/coupons'
import home from './modules/home'
import token from './modules/token'
import resolution from './modules/resolution'
import canvas from "./modules/canvas"
//挂载Vuex
Vue.use(Vuex)

//创建VueX对象
export default new Vuex.Store({
    modules: {
        resolution,
        shoplogin: shoplogin,
        coupons: coupons,
        home:home,
        token,
        canvas
    }
})